import { defineStore } from "pinia"

export const usePreloadStore = defineStore({
    id: "prealod",
    state: () => ({
        show: false as boolean,
        count: 0,
    }),
    actions: {
        showPreload(show: boolean) {
            this.show = show
        },
        startPreload() {
            this.count++
            this.show = true
        },
        finishPreload() {
            if (this.count > 0) {
                this.count--
            }
            if (this.count === 0) {
                this.show = false
            }
        },
    },
})
